import axios from 'axios';

const aiChatService = {
  async getCompanyId() {
    try {
      const apiUrl = import.meta.env.VITE_API_URL || 'https://quantifaid-backend-757948789112.us-central1.run.app';
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('Authentication token is missing. Please log in again.');
      }

      console.log('Fetching company ID from:', `${apiUrl}/auth/me/company-info`);

      const response = await fetch(`${apiUrl}/auth/me/company-info`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error fetching company ID:', errorText);
        throw new Error('Failed to fetch company ID');
      }

      const data = await response.json();
      console.log('Company ID:', data.company_id);
      return data.company_id;
    } catch (error) {
      console.error('Error in getCompanyId:', error);
      throw error;
    }
  },

  async sendMessage(companyId, message) {
    try {
      if (!companyId) {
        companyId = await this.getCompanyId();
      }
      if (!message) {
        throw new Error('Message is required');
      }
      const apiUrl = import.meta.env.VITE_API_URL || 'https://quantifaid-backend-757948789112.us-central1.run.app';
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('Authentication token is missing. Please log in again.');
      }

      console.log('Sending chat message to:', `${apiUrl}/ai-chat/chat`);
      console.log('Request payload:', { company_id: companyId, message });

      const response = await fetch(`${apiUrl}/ai-chat/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          company_id: companyId,
          message: message
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Chat API Error:', {
          status: response.status,
          statusText: response.statusText,
          body: errorText
        });
        
        // Check for specific error types
        if (response.status === 401) {
          throw new Error('Session expired. Please log in again.');
        } else if (response.status === 500) {
          throw new Error('Server error. Our team has been notified.');
        }
        
        throw new Error('Failed to get AI response');
      }

      const data = await response.json();
      console.log('Chat API Response:', data);
      return data.response;
    } catch (error) {
      console.error('Error in AI chat service:', error);
      throw error;
    }
  }
};

export default aiChatService; 